export const NAME = "publicEmergencyOrders" as const;
export const PRODUCT_PACKAGES_ARRAY_FIELD = "emergencyOrderProductPackages";

export const CUSTOMER_ID_FIELD = "customerId";
